import React from 'react';
import "./actionRequired.scss";
import Dropzone from "react-dropzone";
import DocumentItem from "../DocumentItem/documentitem";
import { DOCUMENTS_UPLOAD_CATEGORIES } from "../../../constants";
import { setPageNameSiteSection, updateStandardDataLayerAttributes } from "../../../analytics/adobe";
import { documentUploadDataLayer } from "../../../analytics/adobe/pendDataLayerValues";

export class ActionRequired extends React.Component {
  constructor(props) {
    super(props);
    const docCategories ={ ...DOCUMENTS_UPLOAD_CATEGORIES };
    this.state = {
      reasons: this.props.offerPreFilled.pendingReasons,
      files: [],
      completeUpload: false,
      fileUploaderToggle: false,
      documentCategory: "FRAUD",
      EMPTY: { cat: "FRAUD", files: [] },
      tempFiles: [],
      docCategories: docCategories,
      selectedCategory: "FRAUD",
      fileLengthError: false,
      fileInvalidFormat: false,
      uploadedDocuments: [],
      maxFilesExceeded: false,
      fileCount: 0,
      uploadedDocumentsCount: 0,
      totalFileCount: 0,
      maxSize: 0,
      description: [],
      maxLength: 5242880,
      duplicateFiles: []
    };
  }
  componentWillMount() {
    let uploadedDocuments = [...this.props.offerPreFilled.uploadedDocuments];

    const pendingReasons = this.props.offerPreFilled.pendingReasons;
    const uniqueDesc = new Set();
    pendingReasons.map((item, index) => {
      if(item.documentCategory==="FRAUD" && item.description){
        item.description.split(",").map((value, index1) =>{
          uniqueDesc.add(value);
        });
      } else if(this.state.docCategories[item.type]){
        this.state.docCategories[item.type]["docsNeeded"].map((value, index2) =>{
          uniqueDesc.add(value);
        });
      }
    });
    this.setState({
      uploadedDocuments: uploadedDocuments||[],
      maxSize: uniqueDesc.size,
      description: uniqueDesc
    });
  }
  componentDidMount() {
    const { pageName, siteSection }=documentUploadDataLayer;
    updateStandardDataLayerAttributes(setPageNameSiteSection(pageName, siteSection), true);
  }
  onDrop = (acceptedFiles, onDropRejected) => {
    this.setState({ duplicateFiles: [] });
    let onDropcount = acceptedFiles.length + this.state.totalFileCount;
    const maxSize =this.state.maxSize;
    let isDuplicateFile = false;
    if (onDropcount <= maxSize){
      isDuplicateFile = this.isDuplicateFiles(acceptedFiles);
      if (acceptedFiles && acceptedFiles.length > 0 && !isDuplicateFile) {
        const files = this.getFilesExcludedSelectedCat();
        const catFile = this.findByCategory() || this.getReadyObject();
        const file = [...catFile.files];

        for (let index in acceptedFiles) {
          file.push(acceptedFiles[index]);
        }
        catFile.files = file;
        let fileCount = catFile.files.length;
        let totalFileCount = acceptedFiles.length + this.state.totalFileCount;
        files.push({ ...catFile });
        this.setState({
          totalFileCount: totalFileCount,
          fileCount: fileCount,
          files: files,
          tempFiles: [catFile]
        });
      }
    }
    this.setState({ maxFilesExceeded: (onDropcount > maxSize) });

    if(onDropRejected && onDropRejected.length > 0){
      onDropRejected.map((item, index) =>{
        if(item.size > this.state.maxLength){
          this.setState({
            fileLengthError: true,
            fileInvalidFormat: false
          });
        } else{
          this.setState({
            fileLengthError: false,
            fileInvalidFormat: true
          });
        }
      });
    } else{
      this.setState({
        fileLengthError: false,
        fileInvalidFormat: false
      });
    }
  };

  isDuplicateFiles =(currentFiles)=>{
    const files =[...this.state.files];
    const cF =[], length = currentFiles.length;
    let duplicateFiles=[];
    for(let i =0;i <length; i++){
      cF.push(currentFiles[i].name);
    }
    let results = files.filter((item, index) => {
      return (item.files.filter((file, i) => {
        const isFound = (cF.indexOf(file.name) !== -1);
        if(isFound){
          duplicateFiles.push(file.name);
        }
        return isFound;
      }));
    });
    this.setState({ duplicateFiles: duplicateFiles });
    return duplicateFiles.length > 0;

  };
  getReadyObject=()=>{
    const obj={ ...this.state.EMPTY };
    obj.cat=this.state.documentCategory;
    return obj;
  }
  findByCategory=()=>{
    const files=[...this.state.files];
    const obj=files.find(file=>file.cat === this.state.documentCategory);
    if(obj){
      return { ...obj };
    }
    return obj;
  }

  getFilesExcludedSelectedCat=()=>{
    const files=[...this.state.files];
    return files.filter(file=>file.cat !== this.state.documentCategory);
  }

  exceptBy=(cat)=>{
    const files=[...this.state.files];
    return files.filter(file=>file.cat !== cat);
  }
  deleteItem = (name) => {
    const fileGroup=this.getFilesExcludedSelectedCat();
    const catFile = this.findByCategory();
    const files=[...catFile.files];
    const tempFiles=[];
    let isRemoved=false;
    let fileCount=0;
    for(let index in files){
      const newFiles = files.filter(fn =>fn.name !== name);
      if(newFiles.length === 0){
        isRemoved =true;
      }else if(newFiles.length !== files.length){
        catFile.files=newFiles;
      }
    }
    if(!isRemoved){
      fileGroup.push({ ...catFile });
      tempFiles.push({ ...catFile });
      fileCount = catFile.files.length;
    }else{
      this.updateReasonList(this.state.documentCategory, false);
    }
    let totalFileCount = this.state.totalFileCount;
    totalFileCount = totalFileCount !== 0? totalFileCount - 1:0;
    this.setState({
      files: fileGroup,
      tempFiles: tempFiles,
      totalFileCount: totalFileCount,
      fileCount: fileCount,
      maxFilesExceeded: false,
      fileLengthError: false,
      fileInvalidFormat: false
    });
  };

  completeUpload = (isComplete) => {
    const skipUploadDoc=(isComplete && this.state.uploadedDocuments.length === 5);
    this.props.uploadRequiredDocs(this.state.files, isComplete, { mover: this.props.history, nextPage: "/clapply/action/customizePendingOffer/underReview" }, this.props.offerPreFilled.logoutUrl, skipUploadDoc);
  }
  toggleFileUploader=(docCat, name, type, isDone)=>{
    let cat=this.state.documentCategory;
    const selectedCategory =type?this.state.docCategories[type]:null;
    this.setState({
      fileUploaderToggle: !this.state.fileUploaderToggle,
      documentCategory: docCat||null,
      displayDocumentName: name,
      tempFiles: [],
      selectedCategory: selectedCategory
    });
  }
  loadUploadedDocs=()=>{
    const obj = this.findByCategory();
    const tempFiles=obj?[obj]:[];
    this.setState({
      tempFiles: tempFiles
    });
  };
  updateReasonList=(cat, isGreen)=>{
    let reasons=[...this.state.reasons];
    reasons= reasons.map((rs, i)=>{
      if(rs.documentCategory === cat){
        rs.isDone=isGreen;
      }
      return rs;
    });
    this.setState({ reasons: reasons });
  }
  updatePostData=(isDone, cat)=>{
    if(isDone){
      this.updateReasonList(cat, true);
    }else{
      this.updateReasonList(cat, false);
      const files=this.exceptBy(cat);
      this.setState({ files: files });
    }
  }

  render() {
    let isActive = (this.state.uploadedDocumentsCount === 5);
    if(!isActive){
      isActive = !(this.state.totalFileCount > 0);
    }

    let itemList =[];
    const desc =this.state.description;
    desc.forEach((item, index) => {
      itemList.push(<li key={index}>{item}</li>);
    });

    return (
      <div className="action-card">
        <div className="action-heading2 action-xs-hidden standard-blue text-center border-bottom-d3">Action required</div>
        <div className="action-body">
          <div className="action-heading1">Here's what we'll need</div>
          <p className="m-b-175rem">We need you to provide some additional documentation before we can proceed with your
              loan application.</p>
          <div className="dark-blue-43 font-weight-400">Documents we'll need</div>
          <p>{`You will need to upload the following ${itemList.length} ${itemList.length>1?'documents:':'document:'}`}</p>
          <div className="row">
            <ul className="m-b-175rem">
              {itemList}
            </ul>
          </div>

          <div className="action-fileformate">
            <p className="f600">File format and size</p>
            <p className="">The maximum file size is 5MB. We accept .pdf, .bmp, .png, .jpeg, .jpg, .doc, .docx, .gif</p>
          </div>
          <div className="action-Addfile">
            <div className="dark-blue-43 font-weight-400 margin-bottom-20">Your documents</div>
            <label htmlFor="doc-dropzone" id="dropInput">
              <Dropzone data-track="customlinks" onDrop={this.onDrop} className="dropzone-textarea" id="doc-dropzone"
                maxSize={this.state.maxLength}
                accept="application/pdf,image/bmp,image/x-windows-bmp,image/png,image/jpeg,image/pjpeg,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/gif"
              >
                <p className="font-weight-400" data-track="customlinks" aria-label="Add file or drop files here"><span className="file-upload-icon">&#128206;</span><button
                  type="button" className="accessibileAddFileBtn" tabIndex="-1">Add file</button><span className="action-xs-visible-inline standard-blue">(s)</span><span className="action-xs-hidden"> or drop files here</span></p>
              </Dropzone>
            </label>
            {this.state.fileLengthError?
              <p className="color-red font-weight-400" role="alert">Please upload documents that do not exceed 5MB.</p>
              :null
            }
            {this.state.fileInvalidFormat?
              <p className="color-red font-weight-400" role="alert">Please upload documents in the following formats: .pdf, .bmp, .png, .jpeg, .jpg, .doc, .docx, .gif</p>
              :null
            }
            {this.state.maxFilesExceeded?
              <p className="color-red font-weight-400" role="alert">Exceeded total file count: {this.state.maxSize}</p>
              :null
            }
            {this.state.duplicateFiles.length>0?
              <p className="color-red font-weight-400" role="alert">You have already uploaded {this.state.duplicateFiles.join(", ")}.</p>
              :null
            }

            <DocumentItem uploadedDocuments={this.state.uploadedDocuments} items={this.state.tempFiles} deleteItem={this.deleteItem}/>
          </div>

          <p>Once you have added all of your documents, click 'Submit for review' to finish.</p>
          <div className="text-btn-center add-bank text-center">
            <button type="submit" className="btn-continue-padding button-override-color mr-left action-close display-none" value="close" disabled={isActive} onClick={(e)=>this.completeUpload(false)}>close</button>
            <button data-track="custom-links" type="submit" className="btn-continue-padding button-override-color mr-left action-submit" value="review" disabled={this.state.totalFileCount < 1} onClick={(e)=>this.completeUpload(true)} >Submit for review</button>
          </div>
        </div>
      </div>

    );
  }
}
export default ActionRequired;
